import GlobalStyles from '@/components/global-styles/GlobalStyles';
import ResetStyles from '@/components/reset-styles/ResetStyles';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var PageStyles = function PageStyles() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ResetStyles, {}), /*#__PURE__*/_jsx(GlobalStyles, {})]
  });
};
export default PageStyles;